import script from "./approval-remind.vue?vue&type=script&lang=ts&setup=true"
export * from "./approval-remind.vue?vue&type=script&lang=ts&setup=true"

import "./approval-remind.vue?vue&type=style&index=0&id=12fbf16a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12fbf16a"]])

export default __exports__